import Location from 'react-app-location';

export const SettingsLocation = new Location('/settings');
